import mixpanel from "mixpanel-browser/dist/mixpanel.cjs"
import useSiteMetadata from "../../hooks/use-site-metadata"

function Mixpanel() {
  const token = useSiteMetadata().mixpanelToken

  if (token) {
    mixpanel.init(token, {
      track_pageview: true,
    })
  }

  return null
}

export default Mixpanel
